// import { handleFilePreProcess } from "./sonae-img-pre-processor.js";
import {
    createProductItem,
    populateSuggestedProducts,
    showSuggestedProducts,
    populateNotFoundProducts
} from "@theme/ai-helpers";

document.addEventListener('DOMContentLoaded', function () {
    const localhostURL = 'http://127.0.0.1';
    const isDevEnv = location?.href.startsWith(localhostURL);
    const otherSuggestionsModal = document.querySelector('#otherSuggestionsModal');
    const errorModal = document.querySelector('#error-message-modal');
    errorModal?.querySelector(".modal-footer")?.classList.remove("hide");
    const loginModal = document.querySelector('#ai-page-login');
    const addToCartModal = document.querySelector('#ai-add-to-cart-popup');
    const otpMailBtn = document.querySelector("#ai_page_otp_mail_btn");
    const addToCartBtn = document.querySelector(".add-suggested-products-to-cart");
    const loaderModal = document.querySelector("#full-page-loader-modal");
    loaderModal.querySelector(".form-loader").classList.add("ai-page-loader");
    const uploadAnotherListBtn = document.querySelector("#upload-another-list");
    const uploadAnotherListBtn2 = document.querySelector("#upload-another-list-btn2");
    const confirmationModal = document.querySelector("#confirm-action-modal");
    const AUTH_COOKIE_NAME = "ai_page_token";
    const TEMP_COOKIE = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NCwiZW1haWwiOiJ0ZXN0QHRlc3QuY29tIiwicm9sZSI6MiwiaWF0IjoxNzkwODY0ODUzLCJleHAiOjE3OTg4MjM2MjJ9.PtA_eb-xPocXllI_V0pHfJ-EYVjhYktRr02ia8dob_0";
    let tempFiles = null;
    const SONAE_AI_URL = isDevEnv ? localhostURL+':3000' : "https://sonae-ai-backend.production.theloop.tech";
    let currentJobId = null;
    const UPPER_LIMIT_SKU_TO_FETCH = 9;
    const LOADING_TEXT = [
        "☕ O processo pode demorar até 2 minutos… aproveita para beber um café ou relaxar.",
        "📄 Para obteres o melhor resultado, certifica-te de que a tua lista está legível e em boa resolução.",
        "🤖 Estamos a preparar a tua seleção! A IA faz o trabalho pesado, mas pode precisar da tua revisão, trocas e ajustes.",
        "🛒 O processo é simples: escolhe os artigos de que precisas, substitui se quiseres e adiciona-os ao carrinho.",
        "🚀 Este é um projeto piloto — depois da compra, conta-nos o que achaste para continuarmos a melhorar.",
        "⏳ Está quase pronto… a paciência é uma virtude e a tua lista também vai valer a pena! 😉"
    ];

    try {
        // Check for existing suggestions and Populate page if found
        const lastSuggestions = localStorage.getItem("ai_suggested_products");
        let itemsPopulatedFromList = lastSuggestions ? JSON.parse(lastSuggestions)?.products : {};

        if (
            typeof itemsPopulatedFromList == "object" &&
            Object.values(itemsPopulatedFromList).length > 0
        ) {
            const allShopifyProducts = [];

            Object.values(itemsPopulatedFromList).forEach((item) => {
                item.product.hasOtherOptions = item?.otherProducts.length > 0;

                const { productItem } = createProductItem(item.product, itemsPopulatedFromList);
                allShopifyProducts.push(productItem);
            });
            showSuggestedProducts(allShopifyProducts);
        }
    } catch (error) {
        console.log("LocalStorage error: ", error?.message);
    }

    function displayErrorModal(text, duration = 6000) {
        errorModal.querySelector("#error-message").textContent = text;
        errorModal.show();
        setTimeout(() => {
            errorModal.hide();
            errorModal.querySelector("#error-message").textContent = "";
        }, duration);
    }

    // Define an array of asset URLs for the falling graphics INSIDE DOMContentLoaded
    const fallingGraphicAssetUrls = [
        document.querySelector(`#animation-svg-1`)?.src,
        document.querySelector(`#animation-svg-2`)?.src,
        document.querySelector(`#animation-svg-3`)?.src,
        document.querySelector(`#animation-svg-4`)?.src,
        document.querySelector(`#animation-svg-5`)?.src
    ];

    const dropzoneElement = document.querySelector('.dropzone');
    const inputElement = dropzoneElement.querySelector('.dropzone__input');
    const uploadUrl = dropzoneElement.dataset.uploadUrl;
    const maxFiles = parseInt(dropzoneElement.dataset.maxFiles, 1);
    const MAX_BYTES_PER_FILE = 1 * 1024 * 1024; // 1 MB
    const acceptedFiles = dropzoneElement.dataset.acceptedFiles.split(',');
    const dropzoneIcon = dropzoneElement.querySelector('.dropzone__icon');
    const dropzoneTextContainer = dropzoneElement.querySelector('.dropzone__text');
    const dropzoneUploadingContainer = dropzoneElement.querySelector('.dropzone__uploading');
    const primaryTextElement = dropzoneElement.querySelector('.dropzone__text--primary');
    const secondaryTextElement = dropzoneElement.querySelector('.dropzone__text--secondary');
    const loadingTextElement = document.querySelector('.dropzone__uploading-text');
    let animationInterval = null;
    let loadingTextInterval = null;

    dropzoneUploadingContainer.style.display = 'none';

    dropzoneElement.addEventListener('click', () => {
        if (!dropzoneElement.classList.contains('dropzone--uploading')) {
            inputElement.click();
        }
    });

    inputElement.addEventListener('change', (event) => {
        handleFiles(event.target.files);
    });

    dropzoneElement.addEventListener('dragover', (event) => {
        event.preventDefault();
        if (!dropzoneElement.classList.contains('dropzone--uploading')) {
            dropzoneElement.classList.add('dropzone--over');
        }
    });

    dropzoneElement.addEventListener('dragleave', () => {
        dropzoneElement.classList.remove('dropzone--over');
    });

    dropzoneElement.addEventListener('drop', (event) => {
        event.preventDefault();
        dropzoneElement.classList.remove('dropzone--over');
        if (!dropzoneElement.classList.contains('dropzone--uploading')) {
            const files = event.dataTransfer.files;
            handleFiles(files);
        }
    });

    function handleFiles(files) {
        if (files.length === 0) return;

        if (files.length > maxFiles) {
            displayErrorModal(`Pode selecionar no máximo ${maxFiles} ficheiro.`);
            inputElement.value = '';
            return;
        }
        
        let validFiles = [];
        let invalidFileNames = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
            if (acceptedFiles.includes(fileExtension)) {
                validFiles.push(file);
            } else {
                invalidFileNames.push(file.name);
            }
        }

        if (invalidFileNames.length > 0) {
            displayErrorModal(`Ficheiro inválido: ${invalidFileNames.join(', ')}. Tipos aceites: ${acceptedFiles.join(', ')}`);
        }

        if (validFiles.length > 0) {
            if (validFiles[0].size > MAX_BYTES_PER_FILE) {
                displayErrorModal(`O ficheiro "${validFiles[0].name}" excede o tamanho máximo de 1 MB.`);
                return;
            }

            if (validFiles.length === 1) {
                primaryTextElement.textContent = validFiles[0].name;
                secondaryTextElement.textContent = `(${formatBytes(validFiles[0].size)})`;
            } else {
                primaryTextElement.textContent = `${validFiles.length} ficheiros selecionados`;
                let totalSize = 0;
                validFiles.forEach(f => totalSize += f.size);
                secondaryTextElement.textContent = `(Total: ${formatBytes(totalSize)})`;
            }
            uploadFiles(validFiles);
        } else if (files.length > 0 && validFiles.length === 0) {
            primaryTextElement.textContent = 'SELECIONAR FICHEIRO';
            secondaryTextElement.textContent = '(TXT, PNG, JPG, JPEG ou PDF)';
        }
        inputElement.value = '';
    }

    document.querySelector("#submit-list-textarea")?.addEventListener("click", (e) => {
        e.preventDefault();
        const textarea = document.querySelector("#list-textarea");
        const textValue = textarea?.value?.trim();
        if (!textValue) {
            displayErrorModal("Por favor, insere a tua lista escolar.");
            return;
        }
        const blob = new Blob([textValue], { type: 'text/plain' });
        const file = new File([blob], generateDefaultFilename(), { type: 'text/plain' });
        uploadFiles([file]);
        document.querySelector("#steps-list-end")?.scrollIntoView({ behavior: "smooth" });
    });

    function generateDefaultFilename() {
        const currentTime = new Date();
        const pad = (n) => String(n).padStart(2, '0');
        const stamp = `${currentTime.getFullYear()}-${pad(currentTime.getMonth() + 1)}-${pad(currentTime.getDate())}_${pad(currentTime.getHours())}-${pad(currentTime.getMinutes())}-${pad(currentTime.getSeconds())}`;
        return `note_${stamp}.txt`;
    }

    async function uploadFiles(files) {
        const isAuth = await isAuthenticated();
        if (!isAuth) {
            tempFiles = files;
            return;
        }

        let suggestions = [];
        let shopifyProducts = [];

        console.log('Mock uploading files:', files);
        console.log('Upload URL:', uploadUrl);

        dropzoneElement.scrollIntoView({ behavior: "smooth" });
        dropzoneElement.classList.add('dropzone--uploading');
        dropzoneUploadingContainer.style.display = 'flex';
        startFallingAnimation();
        startLoadingTextAnimation();
        // Get processed OCR data from file
        // const fileResponse = await processFile(files);

        //Check uploaded file text readability
        // const isQualityOk = await handleFilePreProcess(files[0]);
        // // console.log({isQualityOk})
        // if (!isQualityOk) {
        //     let errorMessage = "A qualidade da imagem é baixa!";
        //     displayErrorModal(errorMessage, 3000);
        //     resetDropzone();
        //     return;
        // }
        
        // if (fileResponse.status == "ok") {
        const productSuggestionsRes = await getProductSuggestions(files);

        if (productSuggestionsRes.status == 'ok') {
            suggestions = productSuggestionsRes.data;

            shopifyProducts = await getShopifyProductsData(suggestions);
            // console.log({shopifyProducts});
        } else {
            resetDropzone();
        }

        const { allShopifyProductsSkus, itemsWithNoFoundProducts } = populateSuggestedProducts(shopifyProducts, currentJobId);
        populateNotFoundProducts(itemsWithNoFoundProducts);
        stopFallingAnimation();
        stopLoadingTextAnimation();
    }

    function startLoadingTextAnimation() {
        document.querySelector("#list-text-input")?.classList.add("hide");

        if (loadingTextInterval) clearInterval(loadingTextInterval);
        let index = 0;
        loadingTextElement.textContent = LOADING_TEXT[index];

        loadingTextInterval = setInterval(() => {
            index = (index + 1) % LOADING_TEXT.length;
            loadingTextElement.textContent = LOADING_TEXT[index];
        }, 8000);
    }
    function stopLoadingTextAnimation() {
        if (loadingTextInterval) {
            clearInterval(loadingTextInterval);
            loadingTextInterval = null;
            loadingTextElement.textContent = '';
        }
    }

    function resetDropzone() {
        stopFallingAnimation();
        dropzoneElement.classList.remove('dropzone--uploading');
        dropzoneUploadingContainer.style.display = 'none';
        primaryTextElement.textContent = 'SELECIONAR FICHEIRO (máx. 1 MB)';
        secondaryTextElement.textContent = '(TXT, PNG, JPG, JPEG ou PDF)';
        document.querySelector("#list-text-input")?.classList.remove("hide");
    }

    async function processFile(files) {

        try {
            let userToken = getCookie(AUTH_COOKIE_NAME);
            const fileFormData = new FormData();
            fileFormData.append('file', files[0]);
        
            const fileRes = await fetch(`${SONAE_AI_URL}/process/file`, {
                method: "POST",
                body: fileFormData,
                headers: {
                    Authorization: `Bearer ${userToken}`,
                }
            });
        
            const resData = await fileRes.json();

            if (fileRes.ok && resData){
                return {status: 'ok', data: resData};
            }
            else if (fileRes.status == 500 && resData?.message) {
                let errorMessage = resData?.message?.toLowerCase();
                errorMessage = errorMessage?.includes("unavailable") || errorMessage?.includes("overload") ?
                    "O modelo de IA está sobrecarregado." :
                    errorMessage;
                displayErrorModal(errorMessage);
                return {status: 'error', error: errorMessage};
            } else {
                throw new Error("Error processing file!");
            }
        } catch (error) {
            const errorMessage = error?.message?.message || "Error";

            errorModal.show();
            return {status: 'error', error: errorMessage};
        }
    }

    async function getProductSuggestions (files) {
        try {
            let userToken = getCookie(AUTH_COOKIE_NAME);
            let customerEmail = document.querySelector("#customer_email")?.value;
            const fileFormData = new FormData();
            fileFormData.append('file', files[0]);
            if (customerEmail) fileFormData.append('email', customerEmail);

            const threeMinutes = 1000 * 60 * 3;

            // const timeoutId = setTimeout(() => controller.abort(), threeMinutes)

            // const suggestRes = await fetch(`${SONAE_AI_URL}/process/product-suggestions`, {
            //     method: "POST",
            //     body: fileFormData,
            //     headers: {
            //         Authorization: `Bearer ${userToken}`
            //     },
            //     signal: AbortSignal.timeout(threeMinutes)
            // });
            const suggestRes = await axios({
                method: "post",
                url: `${SONAE_AI_URL}/process/product-suggestions/note`,
                data: fileFormData,
                headers: {
                    Authorization: `Bearer ${userToken}`
                },
                timeout: threeMinutes,
            });
        
            const resData = await suggestRes;

            if (resData.status == 201 && resData?.data){
                currentJobId = resData.data?.jobId;
                const { promise: suggestionsPromise, cancel } = pollStatus(`${SONAE_AI_URL}/process/job/${currentJobId}/status`, {
                    interval: 20000, //20 seconds
                    timeout: 240000, //4 minutes
                    maxAttempts: 20,
                    onStatus: (status, data) => {
                        // console.log('Current status:', status);
                    }
                });

                const suggestionsResult = await suggestionsPromise
                    .then(finalData => {
                        console.log('Processing complete!', finalData);
                        return finalData;
                    })
                    .catch(err => {
                        console.error('Polling error or timeout:', err);
                        throw new Error(err || "Erro!");
                    });

                return {status: 'ok', data: suggestionsResult?.result};
            } else {
                throw new Error("Error getting suggestions!");
            }
        } catch (error) {
            const errorMessage = error?.message || error?.message?.message || "Erro!";

            console.log("Request error::", errorMessage?.name);
            if (error?.name === "TimeoutError") {
                console.error("Timeout:");
            }
            if (error?.name === 'AbortError') {
                console.log('Fetch request timed out or was aborted.');
            }

            errorModal.querySelector("#error-message").textContent = errorMessage;
            errorModal.show();

            return {status: 'error', error: errorMessage};
        }
    }

    function pollStatus(url, {
        interval = 5000,
        timeout,
        maxAttempts = 10,
        onStatus
    } = {}) {
        let attempts = 0;
        let cancelled = false;
        let timeoutId;
        let controller = new AbortController();

        const startTime = Date.now();

        const promise = new Promise((resolve, reject) => {
            function doPoll() {
                if (cancelled) return;

                // Check timeout / attempts
                if (typeof maxAttempts === 'number' && attempts >= maxAttempts) {
                    return reject(new Error('Max polling attempts exceeded'));
                }
                if (typeof timeout === 'number' && (Date.now() - startTime) >= timeout) {
                    return reject(new Error('Polling timed out'));
                }

                let userToken = getCookie(AUTH_COOKIE_NAME);

                attempts++;
                fetch(url, {
                    headers: {
                        Authorization: `Bearer ${userToken}`
                    },
                    signal: controller.signal 
                })
                .then(res => {
                    if (!res.ok) throw new Error(`HTTP ${res.status}`);
                    return res.json();
                })
                .then(data => {
                    const status = data.status;
                    if (onStatus) {
                        try { onStatus(status, data); } catch (_) { /* swallow */ }
                    }

                    if (status === 'completed') {
                        return resolve(data);
                    }

                    if (status === 'failed') {
                        throw new Error("O modelo de IA está sobrecarregado. Tente novamente em breve.");
                    }

                    // Schedule next poll
                    timeoutId = setTimeout(doPoll, interval);
                })
                .catch(err => {
                    // If aborted, just exit
                    if (err.name === 'AbortError') return;
                    reject(err);
                });
            }

            doPoll();
        });

        return {
            promise,
            cancel() {
                cancelled = true;
                controller.abort();
                clearTimeout(timeoutId);
            }
        };
    }

    async function getShopifyProductsData (productsRes) {
        let allProductsSkuArr = [];
        const productSuggestionsList = productsRes;
        let skuProductNameMap = {};

        productsRes.forEach(({ key, products }) => {
            products?.slice(0, UPPER_LIMIT_SKU_TO_FETCH).forEach((productItem) => {
                if (productItem.sku) {
                    allProductsSkuArr.push(productItem.sku);
                    skuProductNameMap[`${productItem.sku}`] = `${key}`;
                }
            })
        });


        if (allProductsSkuArr.length == 0) return [];
        try {
            const shopifyProductsRes = await fetch('https://sonae-shopify-app.production.theloop.tech/products-by-sku', {
                method: "POST",
                headers: {
                    "Content-Type": 'application/json',
                },
                body: JSON.stringify({
                    data: allProductsSkuArr,
                    jobId: currentJobId
                })
            });
        
            const resData = await shopifyProductsRes.json();
        
            if (shopifyProductsRes.ok && resData){
                let data = resData?.data?.data?.products?.edges || resData?.data?.products?.edges || [];
                // console.log({data})
                return {status: 'ok', data: data, skuProductNameMap, productSuggestionsList };
            } else {
                throw new Error("Error fetching products!");
            }
        } catch (error) {
            const errorMessage = error?.message?.message || "Error";

            errorModal.show();
            return {status: 'error', error: errorMessage};
        }
    }

    document.querySelector("#all_products_select .custom-checkbox__button")?.addEventListener("click", (e) => {

        const checkMark = e.target.closest(".custom-checkbox-container")
            .querySelector(".custom-checkbox__checkmark-icon");
        const checkAll = e.target.closest(".custom-checkbox-container")
            .querySelector(".custom-checkbox__input");

        if (!checkAll.checked) {
            checkAll.checked = true;
            checkMark.style.visibility = "visible";
            document.querySelectorAll(".product-item .custom-checkbox__input")
            .forEach((check) => {
                const mark = check.closest(".custom-checkbox-container")
                    .querySelector(".custom-checkbox__checkmark-icon");
                check.checked = true;
                mark.style.visibility = "visible";
            })
        } else {
            checkAll.checked = false;
            checkMark.style.visibility = "hidden";

            document.querySelectorAll(".product-item .custom-checkbox__input")
            .forEach((check) => {
                const mark = check.closest(".custom-checkbox-container")
                    .querySelector(".custom-checkbox__checkmark-icon");
                check.checked = false;
                mark.style.visibility = "hidden";
            });
        }
    })

    addToCartBtn.addEventListener("click", function(e) {
        e.preventDefault();

        addToCartModal.show();

        // setTimeout(() => {
        //     loaderModal.hide();
        //     document.querySelector('[data-js-sidebar-handle][aria-controls=site-cart-sidebar]').click();
        //     addToCartBtn.style.display = "none";
        // }, loadTime+5000);
    });

    addToCartModal.querySelector("#add-to-cart-cta").addEventListener("click", (e) => {
        addToCartModal.hide();

        loaderModal.show();

        const allProductsArr = [];
        const suggestedProductsGrid = document.querySelector("#suggested-products-grid");
        const allProductItems = suggestedProductsGrid.querySelectorAll(".product-item");
        allProductItems.forEach((productItem, i) => {
            const productForm = productItem.querySelector("product-form");
            const id = productForm.querySelector("form template").content.querySelector("input[name=id]")?.value;
            const quantity = productForm.querySelector("form template").content.querySelector("input[name=quantity]")?.value;

            if (productItem.querySelector(".custom-checkbox__input")?.checked) {
                allProductsArr.push({ id, quantity });
            }
        });

        fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
            body: JSON.stringify({ items: allProductsArr }),
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            method: 'POST'
        })
            .then(response => response.json())
            .then(response => {
                if ( response.status == 422 ) {
                    loaderModal.hide();
                    displayErrorModal(response.message, 5000);

                    if (!response.message?.toLowerCase()?.includes("esgotado")) {
                        setTimeout(() => {
                            window.location.assign("/cart");
                        }, 5000);
                    }
                } else {
                    loaderModal.hide();
                    window.location.assign("/cart");
                }
            })
            .catch(e => {
                console.log(e);
            })
            .finally(() => {

            });
    });

    otherSuggestionsModal.querySelector("#substitute-product-btn")
        .addEventListener("click", (e) => {
            const activeProductId = otherSuggestionsModal.dataset.activeProduct;
            const activeProduct = document.querySelector(`#${activeProductId}`);
            const itemListKey = activeProduct.dataset.listKey;
            const selectedOptionsIds = otherSuggestionsModal.dataset.selectedOptions || "";

            const lastSuggestions = localStorage.getItem("ai_suggested_products");
            let itemsPopulatedFromList = lastSuggestions ? JSON.parse(lastSuggestions)?.products : {};

            const optionsProductData = itemsPopulatedFromList[itemListKey]
                ?.otherProducts
                ?.filter((prod) => selectedOptionsIds.includes(prod.id.split("/").reverse()[0]));

            // itemsPopulatedFromList[itemListName].otherProducts = [
            //     ...itemsPopulatedFromList[itemListName]
            //         .otherProducts?.filter((prod) => prod.id.split("/").reverse()[0] != selectedOptionId),
            //     itemsPopulatedFromList[itemListName].product
            // ];
            // itemsPopulatedFromList[itemListName].product = optionProductData;

            const additionalProducts = [];
            optionsProductData.forEach((option) => {

                option.hasOtherOptions = true;
                const { productItem } = createProductItem(option, itemsPopulatedFromList);
                additionalProducts.push(productItem);
            })

            activeProduct.after(...additionalProducts);
            const activeProductCheckbox = activeProduct.querySelector(".custom-checkbox__input");
            if (activeProductCheckbox?.checked) {
                activeProduct.querySelector(".custom-checkbox__button")?.click();
            }
            otherSuggestionsModal.hide();

            additionalProducts[0]?.scrollIntoView({behavior: "smooth"});
        });

    uploadAnotherListBtn.addEventListener("click", (e) => {
        e.preventDefault();
        //show confirm modal
        confirmationModal.show();
    });
    uploadAnotherListBtn2.addEventListener("click", (e) => {
        e.preventDefault();
        confirmationModal.show();
    });

    confirmationModal.querySelectorAll(".modal-footer button").forEach((btn) => {
        btn.addEventListener("click", (e) => {
            if (e.target.dataset.act == "yes") {
                document.querySelector("#ai-suggestions-block")?.classList.add("hide");
                document.querySelector("#ai-file-dropzone")?.classList.remove("hide");

                localStorage.removeItem("ai_suggested_products");
                resetDropzone();

            }
            confirmationModal.hide();
        });
    })

    function createFallingGraphic() {
        if (fallingGraphicAssetUrls.length === 0) return; 

        const graphic = document.createElement('img');
        graphic.setAttribute("class", "falling-graphic");
        
        const randomSvgUrl = fallingGraphicAssetUrls[Math.floor(Math.random() * fallingGraphicAssetUrls.length)];
        graphic.setAttribute("src", randomSvgUrl);
        graphic.setAttribute("alt", "Falling graphic"); 

        graphic.style.left = `${Math.random() * 90}%`; 
        graphic.style.animationDuration = `${4 + Math.random() * 3}s`; 
        graphic.style.animationDelay = `${Math.random() * 3}s`; 

        dropzoneUploadingContainer.appendChild(graphic);

        graphic.addEventListener('animationend', () => {
        graphic.remove();
        });
    }

    function startFallingAnimation() {
        if (animationInterval) clearInterval(animationInterval);
        // Initial burst of 2-3 graphics
        const initialCount = Math.floor(Math.random() * 2) + 2; // 2 or 3
        for(let i=0; i < initialCount; i++) createFallingGraphic(); 
        // Add new graphics less frequently, aiming for a total of around 5-6 over the animation period
        // If animation is 7s, and we want ~3 more graphics, add one every ~2s
        animationInterval = setInterval(createFallingGraphic, 2000); // Add a new graphic every 2000ms
    }

    function stopFallingAnimation() {
        clearInterval(animationInterval);
        animationInterval = null;
        const existingGraphics = dropzoneUploadingContainer.querySelectorAll('.falling-graphic');
        existingGraphics.forEach(graphic => graphic.remove());
    }

    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        // let name = cname + "=";
        // let ca = document.cookie.split(';');
        // for(let i = 0; i < ca.length; i++) {
        //     let c = ca[i];
        //     while (c.charAt(0) == ' ') {
        //         c = c.substring(1);
        //     }
        //     if (c.indexOf(name) == 0) {
        //         return c.substring(name.length, c.length);
        //     }
        // }
        return TEMP_COOKIE;
    }

    async function isAuthenticated() {
        let userToken = getCookie(AUTH_COOKIE_NAME);
        if (!userToken) {
            loginModal.show();
            return false;
        };

        try {
            const isLoggedInRes = await fetch(`${SONAE_AI_URL}/auth/logged-in`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${userToken}`,
                    Accept: 'application/json',
                    "Content-Type": 'application/json',
                }
            });
        
            const resData = await isLoggedInRes.json();
        
            if (isLoggedInRes.ok && resData){
                return true;
            } else {
                loginModal.show();
                return false;
            }
        } catch (error) {
            const errorMessage = error?.message || "Error";
            console.error(errorMessage);
            loginModal.show();

            return false;
        }
    }

    otpMailBtn?.addEventListener("click", async (e) => {
        e.preventDefault();
        const email = document.querySelector("#ai_customer_email")?.value;

        if (!email) {
            // display error;
            return;
        }
        otpMailBtn.setAttribute("disabled", "true");

        try {
            const otpMailRes = await fetch(`${SONAE_AI_URL}/auth/otp-mail`, {
                method: "POST",
                body: JSON.stringify({ email }),
                headers: {
                    Accept: 'application/json',
                    "Content-Type": 'application/json',
                }
            });
        
            const resData = await otpMailRes.json();
        
            if (otpMailRes.ok && resData){
                // show success message
                // show otp input and button
                otpMailBtn.style.display = "none";
                document.querySelector(".ai_page_otp_input_block").style.display = "flex";
                document.querySelector(".ai_page_otp_login_btn_block").style.display = "flex";

                document.querySelector("#ai_customer_email").style.display = "none";
                document.querySelector("#otp_sent_email").textContent = email;
                document.querySelector("#otp_sent_message")?.classList.remove("hide");

                return true;
            } else {
                throw new Error("OTP invalid or expired!");
            }
        } catch (error) {
            const errorMessage = error?.message || "Error";
            console.error(errorMessage);
            errorModal.show();

            return false;
        }
    });

    document.querySelector("#ai_products_login_form")?.addEventListener("submit", async (e) => {
        e.preventDefault();
        const email = document.querySelector("#ai_customer_email")?.value;
        const otp = document.querySelector("#ai_customer_otp")?.value;

        if (!email || !otp || otp.length != 6) {
            // display error;
            return;
        }

        try {
            const otpLoginRes = await fetch(`${SONAE_AI_URL}/auth/otp-login`, {
                method: "POST",
                body: JSON.stringify({ email, otp }),
                headers: {
                    Accept: 'application/json',
                    "Content-Type": 'application/json',
                }
            });
        
            const resData = await otpLoginRes.json();
        
            if (otpLoginRes.ok && resData){
                setCookie(AUTH_COOKIE_NAME, resData.access_token, 2);
                // show success message
                
                loginModal.hide();
                // handle any existing file
                if (tempFiles) {
                    uploadFiles(tempFiles);
                }
                return true;
            } else {
                document.querySelector(".ai_page_otp_input_block .error-text")?.classList.remove("hide");
            }
        } catch (error) {
            const errorMessage = error?.message || "Error";
            console.error(errorMessage);
            errorModal.show();

            return false;
        }
    });

});